import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import TopPageCMSBannerMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopPageCMSBannerMessage';

function TopContentCanadaPostStrikeMessage({ shouldRender = true, ...rest }) {
    if (!shouldRender) {
        return null;
    }

    return (
        <TopPageCMSBannerMessage
            {...rest}
            alignItems={['start', 'center']}
        />
    );
}

TopContentCanadaPostStrikeMessage.propTypes = {
    shouldRender: PropTypes.bool
};

export default wrapFunctionalComponent(TopContentCanadaPostStrikeMessage, 'TopContentCanadaPostStrikeMessage');
